import { CanPurchaseDomainSuiteErrors, CheckDomainIsTakenErrors } from '../../typing';
import { parseDomain } from '../../utils';
export const canPurchaseDomainSuite = async _ref => {
  let httpClient = _ref.httpClient,
    domain = _ref.request.domain;
  if (!domain) {
    return {
      canPurchase: false
    };
  }
  const _await$import$Domains = (await import('../ApiClients/DomainsApiClient')).DomainsApiClient.queries({
      httpClient
    }),
    checkDomainIsTaken = _await$import$Domains.checkDomainIsTaken;
  const parsedDomain = domain.main ? domain : parseDomain(domain);
  const _await$Promise$all = await Promise.all([checkDomainIsTaken({
      domain: parsedDomain.asciiDomain
    })]),
    _await$Promise$all$ = _await$Promise$all[0],
    isAvailable = _await$Promise$all$.isAvailable,
    premium = _await$Promise$all$.premium,
    error = _await$Promise$all$.error;
  let purchaseError;
  switch (error) {
    case CheckDomainIsTakenErrors.NOT_SUPPORTED_TLD:
      purchaseError = CanPurchaseDomainSuiteErrors.NOT_SUPPORTED_TLD;
      break;
    case CheckDomainIsTakenErrors.NOT_SUPPORTED_TLD_REGIONAL:
      purchaseError = CanPurchaseDomainSuiteErrors.NOT_SUPPORTED_TLD_REGIONAL;
      break;
    default:
      purchaseError = undefined;
      break;
  }
  if (!isAvailable) {
    return {
      error: purchaseError,
      canPurchase: false,
      premium
    };
  }
  return {
    canPurchase: true,
    premium
  };
};
//# sourceMappingURL=canPurchaseDomainSuite.js.map